import { MainArea, Page, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import * as React from 'react';
import { NewUserProvider } from '../context/useNewUserContext';
import NewUserWizard from './NewUserWizard';

export const NewUserWizardPage: React.FC = () => (
  <NewUserProvider>
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>

      <Page padding={0}>
        <NewUserWizard />
      </Page>
    </MainArea>
  </NewUserProvider>
);

export default NewUserWizardPage;
